const Loading = () => {
  return (
    <div className="ch-display--flex ch-justify-content--center ch-align-items--center ac-account__loading">
      <img alt="Loading..." className="ac-account__spinner" />
    </div>
  );
};

export default Loading;
